import { api } from "services/api.service";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";

export async function action({ params }: { params: Record<string, string | undefined> }) {
  const res = await withActionErrorAlert(() =>
    api.request({ method: "DELETE", url: `/location_management/movement_actions/${params.movementActionId}` }),
  );
  if (res?.status && res.status < 400) {
    return redirect("/movement-actions");
  }
  return res;
}
